export default (el) => {
    setTimeout(() => {
        const focusedInput = el.querySelector(":focus")
        if (focusedInput) {
            return
        }
        el.focus()
        const input = el.querySelector("input")
        if (input) {
            input.focus()
        }
    }, 100)
}
